
import company from '@/store/company'
import venue from '@/store/venue'
import whitelabel from '@/store/whitelabel'
import { DealRedemption } from '@/types/Deal'
import Axios, { AxiosError } from 'axios'
import Vue from 'vue'

const messageMap: Partial<Record<string, string>> = {
  'missing code': 'Bitte Code eingeben',
  'missing venue': 'Bitte Geschäft auswählen',
  'user not found': 'Code ungültig (Benutzer gelöscht?)',
  'user not unique':
    'Bitte vergewissern Sie sich, dass alle Benutzer-IDs eindeutig sind',
  'deal not found': 'Code existiert nicht',
  'deal not unique': 'Code mehrfach gefunden',
  'code used': 'Maximale Anzahl an verfügbaren Gutscheinen erreicht',
  'code used for user': 'Der Benutzer hat diesen Code bereits eingelöst',
  'venue not found': 'Ungültiges Geschäft übergeben',
  'invalid code': 'Ungültiger Code',
  'missing sku': 'PZN fehlt',
  'sku not found': 'PZN in Kombination nicht gültig'
}

export default Vue.extend({
  data: () => {
    return {
      code: '',
      sku: '',
      loading: false,
      error: null as string | null,
      showSku: false,
      lastColor: 'primary' as 'primary' | 'success' | 'error',
      venue: localStorage.getItem('selectedVenue'),
      venuesLoading: true,
      collectedRedemptions: [] as Array<{
        redemption: DealRedemption
        sku?: string
      }>,
      errorKind: null as 'sku' | 'venue' | 'code' | null
    }
  },
  created() {
    Vue.filter('formattedDate', this.formattedDate)
  },
  async mounted() {
    this.venuesLoading = true
    try {
      await venue.fetchAll({
        limit: 1000,
        companyId: company.company?._id
      })
    } finally {
      this.venuesLoading = false
    }
  },
  computed: {
    venues() {
      return venue.venues.map(v => ({
        value: v._id,
        text: v.name
      }))
    }
  },
  watch: {
    venues(newVal: Array<{ value: string; text: string }>) {
      if (newVal.length === 1) this.venue = newVal[0].value
    },
    venue(newVal: string | null) {
      if (newVal) localStorage.setItem('selectedVenue', newVal)
    }
  },
  methods: {
    formattedDate(rawDate: string) {
      const date = new Date(rawDate)

      const time = date.toLocaleTimeString('de-DE', {
        hour: '2-digit',
        minute: '2-digit'
      })

      return `${date.toLocaleDateString('de-DE')} um ${time}`
    },
    async redeemCode() {
      this.dismissMessage()
      this.loading = true
      try {
        const result = await Axios.post(
          `/admin/${whitelabel.whitelabel.slug}/redemption/redeemQrCode`,
          {
            code: this.code,
            venue: this.venue,
            sku: this.sku
          }
        )
        this.collectedRedemptions.push({
          redemption: result.data.redemption,
          sku: result.data.sku
        })
        this.error = null
        this.code = ''
        this.sku = ''
        this.lastColor = 'success'
        this.showSku = false
      } catch (e) {
        if ((e as AxiosError).response?.data.code === 'missing sku') {
          this.lastColor = 'primary'
          this.showSku = true
        } else {
          this.lastColor = 'error'
          this.errorKind = (e as AxiosError).response?.data.kind
        }
        this.error =
          messageMap[(e as AxiosError).response?.data.code ?? ''] ??
          (e as AxiosError).message
      } finally {
        this.loading = false
      }
    },
    dismissMessage(callback?: () => any) {
      this.lastColor = 'primary'
      this.error = null
      this.errorKind = null
      if (callback) callback()
    }
  }
})
